// extracted by mini-css-extract-plugin
export default {"header":"MoreInfo_header__wJZKE","wave":"MoreInfo_wave__SGoBB"};